/* eslint-disable @typescript-eslint/no-use-before-define */
import axios from 'axios';
import {
  IIceHockeyCompetition,
  IIceHockeyStandingResponse,
  IIceHockeyMatch
} from '../../interfaces/interfaces';
import { BASE_URL } from '../../config/config';

export const getCompetitions = async (language: string): Promise<IIceHockeyCompetition[]> => {
  const { data: competitions } = await axios.get<IIceHockeyCompetition[]>(
    `${BASE_URL}/icehockey/competitions${language ? `?language=${language}` : ''}`
  );
  return competitions;
};

export const getStandings = async (
  seasonId: string,
  matchDay: number,
  language: string
): Promise<IIceHockeyStandingResponse[]> => {
  const { data: standings } = await axios.get<IIceHockeyStandingResponse[]>(
    `${BASE_URL}/icehockey/standings/season/${seasonId}${getStandingsQueryStrings(
      matchDay,
      language
    )}`
  );
  return standings;
};

export const getMatches = async (
  competitionId: string,
  seasonId: string,
  matchDay: number,
  language: string
): Promise<IIceHockeyMatch[]> => {
  const { data: matches } = await axios.get(
    `${BASE_URL}/icehockey/matches/competition/${competitionId}/season/${seasonId}?status=all&limit=500${getMatchesQueryStrings(
      matchDay,
      language
    )}`
  );
  return matches;
};

function getStandingsQueryStrings(matchDay: any, language: any) {
  return [matchDay, language].reduce((acc: any, curr: any, index: number, arr: any[]): string => {
    if (!acc && !curr) return acc;
    let queryString = acc;
    if (!acc && curr) {
      queryString = '?';
    }
    if (acc && curr) {
      queryString = `${queryString}&`;
    }
    if (index === 0 && curr) {
      queryString = `${queryString}matchDay=${arr[index]}`;
    }
    if (index === 1 && curr) {
      queryString = `${queryString}language=${arr[index]}`;
    }
    return queryString;
  }, '');
}

function getMatchesQueryStrings(matchDay: any, language: any) {
  return [matchDay, language].reduce((acc: any, curr: any, index: number, arr: any[]): string => {
    if (!acc && !curr) return acc;
    let queryString = acc;
    if (curr) {
      queryString = `${queryString}&`;
    }
    if (index === 0 && curr) {
      queryString = `${queryString}matchDay=${arr[index]}`;
    }
    if (index === 1 && curr) {
      queryString = `${queryString}language=${arr[index]}`;
    }
    return queryString;
  }, '');
}
